import { useSettings } from '../contexts/SettingsContext';

export const useThemeColors = () => {
  const { settings } = useSettings();

  if (!settings) {
    return {
      primary: '#22c55e',
      secondary: '#ef4444',
      primaryShades: {
        50: '#f0fdf4',
        100: '#dcfce7',
        200: '#bbf7d0',
        300: '#86efac',
        400: '#4ade80',
        500: '#22c55e',
        600: '#16a34a',
        700: '#15803d',
        800: '#166534',
        900: '#14532d',
      },
      secondaryShades: {
        50: '#fef2f2',
        100: '#fee2e2',
        200: '#fecaca',
        300: '#fca5a5',
        400: '#f87171',
        500: '#ef4444',
        600: '#dc2626',
        700: '#b91c1c',
        800: '#991b1b',
        900: '#7f1d1d',
      }
    };
  }

  const { primaryColor, secondaryColor } = settings.appearance;

  // Função para gerar tons de uma cor
  const generateShades = (color: string) => {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    const adjustColor = (amount: number) => {
      const newR = Math.max(0, Math.min(255, r + amount));
      const newG = Math.max(0, Math.min(255, g + amount));
      const newB = Math.max(0, Math.min(255, b + amount));
      return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
    };

    return {
      50: adjustColor(200),
      100: adjustColor(150),
      200: adjustColor(100),
      300: adjustColor(50),
      400: adjustColor(20),
      500: color,
      600: adjustColor(-20),
      700: adjustColor(-40),
      800: adjustColor(-60),
      900: adjustColor(-80),
    };
  };

  return {
    primary: primaryColor,
    secondary: secondaryColor,
    primaryShades: generateShades(primaryColor),
    secondaryShades: generateShades(secondaryColor),
  };
};

export default useThemeColors;
